<ng-container *transloco="let t">
  @if (isTemporaryClosed || isInventoryBlocked) {
    <div class="closed-message">
      <span class="icon">⛔</span>
      <div class="text-details">
        {{ t('workingHours.closedMessageIntro') }}
        <ng-container></ng-container>
        @if (closureMessage) {
          <div
            #message
            class="subtitle"
            (click)="hasMessageOverflow() && fullClosingMessageDialog.open()"
          >
            {{ closureMessage }}
          </div>
        }
      </div>
    </div>
    <pxw-modal-dialog
      #fullClosingMessageDialog
      [title]="t('workingHours.closedMessageIntro')"
      type="alert"
    >
      <pxw-icon icon="ban" />
      <p>{{ closureMessage }}</p>
    </pxw-modal-dialog>
  } @else {
    @if (isClosed || isAboutToClose) {
      <button class="closed-message" (click)="displayWorkingHours()">
        @if (isAboutToClose) {
          <span class="icon">🕓</span>
          <div class="text-details">
            {{ t('workingHours.aboutToCloseMessageIntro') }}
            <div #message class="subtitle">{{ t('workingHours.closedMessageSubtitle') }}</div>
          </div>
        } @else {
          <span class="icon">😴</span>
          <div class="text-details">
            {{ t('workingHours.closedMessageIntro') }}
            <div #message class="subtitle">{{ t('workingHours.closedMessageSubtitle') }}</div>
          </div>
        }
      </button>
    }
  }
</ng-container>
